import { render, staticRenderFns } from "./wxTaskInfo.vue?vue&type=template&id=fe148ebc&scoped=true"
import script from "./wxTaskInfo.vue?vue&type=script&lang=js"
export * from "./wxTaskInfo.vue?vue&type=script&lang=js"
import style0 from "./wxTaskInfo.vue?vue&type=style&index=0&id=fe148ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe148ebc",
  null
  
)

export default component.exports